import { render, staticRenderFns } from "./SubBox.vue?vue&type=template&id=4f74044d&scoped=true"
import script from "./SubBox.vue?vue&type=script&lang=js"
export * from "./SubBox.vue?vue&type=script&lang=js"
import style0 from "./SubBox.vue?vue&type=style&index=0&id=4f74044d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f74044d",
  null
  
)

export default component.exports